import PropTypes from 'prop-types';
import { PRODUCT_NAME } from '@/config/product';

/**
 * The product mark: a control-chart trace held between two limit lines. Inline SVG, so it stays crisp at any size
 * and needs no external asset. public/favicon.svg carries the same drawing.
 */
const ProductMark = ({ size = 32, ground = '#0E6C7A', stroke = '#FFFFFF', accent = '#7FD6E2', rounded = true, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label={PRODUCT_NAME} {...rest}>
    {ground && <rect width="64" height="64" rx={rounded ? 15 : 0} fill={ground} />}
    <path d="M12 19 H52 M12 45 H52" stroke={accent} strokeWidth="2.5" strokeLinecap="round" strokeDasharray="4 4" />
    <path d="M12 34 L20 28 L27 36 L34 25 L41 33 L48 29 L52 31" stroke={stroke} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);

ProductMark.propTypes = {
  size: PropTypes.number,
  ground: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([false])]),
  stroke: PropTypes.string,
  accent: PropTypes.string,
  rounded: PropTypes.bool,
};

export default ProductMark;
